import React, { useState, useEffect, useRef } from "react";
import styles from "./WhatsappRechargePlans.module.css";
import { whatsappRechangePlans } from "../../Components/mockData";
import { Link,useLocation } from "react-router-dom";
import PlanCard from "../../Components/PlanCard/PlanCard";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import AutomaticBillPayementContent from "../AutomaticBillPayementContent/AutomaticBillPayementContent";
import AutomaticBillSetUpContent from "../AutomaticBillSetUpContent/AutomaticBillSetUpContent";
import RechargeProcessingContent from "../RechargeProcessingContent/RechargeProcessingContent";
import RechargeResultContent from "../RechargeResultContent/RechargeResultContent";
import { url} from "../../Values/constants";
import axiosHandler from "../../Services/axiosHandler";
import { connect, useDispatch } from "react-redux";
import CryptoJS from "crypto-js";
import {cancleRecurring, createOrder, pgiAutoLogin, recurringHistory, recurringOrders} from "../../Services/pgi";
import { useHistory } from "react-router";
import useSearchParams from "react-router-dom"
import AutoPayDetailsContent from "../AutoPayDetailsContent/AutoPayDetailsContent";
import { deviceCheck, tenPercent } from "../../Values/utils";
import { pushToGA } from "../../Services/users";
import Loading from "../../Components/Loading/Loading";
import GSTModal from "../GSTModal/GSTModal";
import { fetchOrganizationData } from "../../Services/organizations";
import FreeTrialActivatedModal from "../FreeTrials/FreeTrialActivatedModal";


interface WhatsappRechargePlansProps {
  user?: any;
  organizationData?: any;
}


const WhatsappRechargePlans: React.FC<WhatsappRechargePlansProps> = ({user,organizationData}) => {
  const [activeFilters, setActiveFilters] = useState<string[]>(["Recharge"]);
  const [iframeCreated, setIframeCreated] = useState(false);
  const [historyData, setHistoryData] = useState<any>();
  const [historyAmount, setHistoryAmount] = useState<any>();
  const [historyVal, setHistoryVal] = useState<any>();
  const [historyCredit, setHistoryCredit] = useState<any>();
  const [historyUsedCredit, setHistoryUsedCredit] = useState<any>();
  const [load, setLoad] = useState(false);
  const [orderData, setOrderData] = useState<any>();
    const [autoPayDetails, setAutoPayDetails] = useState<boolean>(false);
  const [whatsappRechangePlan, setWhatsappRechangePlan] = useState([
    {
      isTopup: false,
      discountedValue: "",
      originalValue: "",
      discountPercent: "",
      validity: "",
      balance: "",
      packageId:"",
      packageName:"",
    }
  ]);
  const [finalwhatsappRechangePlan, setFinalWhatsappRechangePlan] = useState([
    {
      isTopup: false,
      discountedValue: "",
      originalValue: "",
      discountPercent: "",
      validity: "",
      balance: "",
      packageId:"",
      packageName:"",
    }
  ]);
  const [openTryAutoPayModal, setOpenTryAutoPayModal] = useState<boolean>(false);
  const [openSetUpAutoPayModal, setOpenSetUpAutoPayModal] = useState<boolean>(false);
  const [payModal, setPayModal] = useState<any>();
  const [gst, setGst] = useState<any>("");
  // const [responseGst, setResponseGst] = useState<any>("");
  const [tranId, setTranId] = useState<any>("");
  const [recr, setRecr] = useState<any>();
  const [openRechargeProcessing, setOpenRechargeProcessing] = useState<boolean>(false);
  const [rechargeResult, setRechargeResult] = useState<boolean>(false);
  const [offerPrice, setOfferPrice] = useState();
  const [packageId, setPackageId] = useState();
  const [originalPrice, setOriginalPrice] = useState();
  const [val, setVal] = useState();
  const [discountVal, setdiscountVal] = useState();
  const [balance, setBalance] = useState();
  const [result, setResult] = useState<boolean | null>(null);
  const location = useLocation();
  const [price, setPrice] = useState<any>();
  const [orignalPrice, setOrignalPrice] = useState<any>();
  const [unit, setUnit] = useState<any>();
  const [tag, setTag] = useState<any>();
  const [id, setId] = useState<any>();
  const [planName, setplanName] = useState<any>();
  const [date, setDate] = useState<any>();
  const [validityDays, setValidityDays] = useState<any>();
  const [token,setToken] = useState<any>()
  const [topUp, setTopUp] = useState<any>();
  const [isRecurringPay, setIsRecurringPay] = useState<any>("N");
  const [openGstModal, setOpenGstModal] = useState<boolean>(false);
  const [validTill, setValidTill] = useState<any>();
  const [uotPayStatus, setUotPayStatus] = useState<any>();
  const [recurringPayStatus, setRecurringPayStatus] = useState<any>();
  const section = JSON.parse(localStorage.getItem("msgData") || "{}");
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const history = useHistory();
  const queryParameters = new URLSearchParams(window.location.search)
  const pageType = queryParameters.get("type")
  const serviceIds = ["13739",'13780'];
  const [defaultPackage, setDefaultPackage] = useState<any>();
  const [orgPassData, setOrgPassData] = useState<any>();
  const [isPgiFlowAlreadyPunched, setIsPgiFlowAlreadyPunched] = useState("");
  const [showTrialActivatedModal, setShowTrialActivatedModal] = useState(false);
  const [resPage, setResPage] = useState<any>();
   let freeTrail :any


  const isTrialPage = (location.state as any)?.isTrialPage ?? false;
  const marktopScreen=(location.state as any)?.marktopScreen ?? false;

   useEffect(()=>{
    if(payModal==="N"){
      onClickHandler(originalPrice,offerPrice,packageId,val,balance,"N")
    }

    if(payModal==="Y"){
      onClickHandler(originalPrice,offerPrice,packageId,val,balance,"Y")
    }
   },[payModal])
  useEffect(() => {
    if (user?.uid && user?.profile) {
      readProductList()
      pushToGA(
        "event_tracking",
        "read pro",
        "read pro",
        "page load",
        user,
      )
    }

  }, [user])

   useEffect(()=>{
    if(payModal==="N"){
      onClickHandler(originalPrice,offerPrice,packageId,val,balance,"N")
    }

    if(payModal==="Y"){
      onClickHandler(originalPrice,offerPrice,packageId,val,balance,"Y")
    }
   },[payModal])

   useEffect(() => {
    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault();
      if(isTrialPage){
        history.push("/marketing");
      }else if (marktopScreen){
        history.push("/marketing");
      }else{
        history.push("/subscriptionDetails");
      }
     
    };

    window.addEventListener("popstate", handleBackButton);

    // Cleanup event listener
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [history]);


  // console.log("GSTTTT",gst)
  const formattedDate = new Date(date).toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const tagGet = async (id:any) => {
    const apiUrl = url+"/miscellaneous/getTag";
    const payload = {
      id:id,
    };
  // console.log("sendMail--payload",payload)
    try {
      const response = await axiosHandler.post(apiUrl, payload);
    //  console.log("miscellaneous done response",response)
     return response.data.data
    } catch (error:any) {
      // Handle errors
      // console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };

  useEffect(() => {
    const currentSearch = window.location.search || location.search;
    const params = new URLSearchParams(currentSearch);
    const status = params.get("st");
    let val = params.get("val");
  
    // console.log("status", status);
    // console.log("val", val);
    const whatsFunc = async(val:any)=>{
      try {
        // Replace spaces with '+' in the `val` parameter
        val = val.replace(/ /g, "+");
        const decryptTokenParams = { 
              encryptedToken: val,
              url: params,
              usedecryptPAY:true
            };
          const responseObj =  await axiosHandler.get('/auth/decryptToken', { params: decryptTokenParams });
            const decryptedData = responseObj.data.decryptData
        const parsedData = Object.fromEntries(
          decryptedData.split("~").map((item:any) => item.split("="))
        );
        console.log("parsedData", parsedData);
  
        // Extract individual fields
        const ustenddate = parsedData["ustenddate"];
        const uotrfnum = parsedData["uotrfnum"];
        const ustsubdate = parsedData["ustsubdate"];
        const ustspmname = parsedData["ustspmname"];
        const packageId = parsedData["packageId"];
        const originalPrice = parsedData["originalPrice"];
        const price = parsedData["price"];
        const credit = parsedData["credit"];
        const validity = parsedData["validity"];
        const type = parsedData["istoup"];
        const uotpaystatus = parsedData["uotpaystatus"];
        const recurringpaystatus = parsedData["isRecurring"];
         freeTrail = parsedData["tag"]
        const punched = parsedData["punched"]
        // const resgst = parsedData["gst"]
        
        // console.log(`parsedData["tag"]`,parsedData["tag"])
        console.log("freeTrail",freeTrail)
        // console.log("recurringpaystatus",recurringpaystatus)
        // Set state variables
        setPrice(parseInt(price,10) || "0");
        setPackageId(packageId || "")
        setOrignalPrice(parseInt(originalPrice,10) || "0");
        setUnit(credit || "0");
        setplanName(ustspmname||"")
        setDate(ustsubdate||"")
        setValidTill(ustenddate||"");
        setValidityDays(validity||0);
        setId(uotrfnum || "");
        setTopUp(type)
        setUotPayStatus(uotpaystatus)
        setRecurringPayStatus(recurringpaystatus?recurringpaystatus:"Y")
        setTag(freeTrail?freeTrail:"")
        setIsPgiFlowAlreadyPunched(punched ? punched : "")
        // setResponseGst(resgst?resgst:"")
  
      } catch (error) {
        console.error("Error processing the decrypted data:", error);
      }
    }
  
    if (val) {
     whatsFunc(val)
    }
  // console.log("setRecurringPayStatus",recurringPayStatus)
    // Handle status
    if (status === "s") {
      setRechargeResult(true);
      setShowTrialActivatedModal(true)
      setResult(false);
      // sendMail(validityDays, id, price, unit,planName);
    } else if (status === "f") {
      setRechargeResult(true);
      setResult(true);
      
    }
  }, [location]);
  


  const handleFilterClick = (filter: string) => {
    setActiveFilters((prevFilters) => {
      if (prevFilters.includes(filter)) {
        return prevFilters.filter((f) => f !== filter);
      } else {
        return [...prevFilters, filter];
      }
    });
    
  };


  const filterData = (data: any[], activeFilters: string[]) => {
    if (activeFilters.includes("Topup") && activeFilters.includes("Recharge")) {
      // Return all data if both filters are active
      // console.log(data);
      return data;
    }
  
    if (activeFilters.includes("Topup")) {
      // Filter data where isTopup is true
      const filteredData = data.filter(item => item.isTopup === true);
      // console.log(filteredData);
      return filteredData;
    }
  
    // Otherwise, filter data where isTopup is false
    const filteredData = data.filter(item => item.isTopup === false);
    // console.log(filteredData);
    return filteredData;
  };

  // console.log("finalwhatsappRechangePlan",finalwhatsappRechangePlan)


  useEffect(()=>{
    setFinalWhatsappRechangePlan(filterData(whatsappRechangePlan,activeFilters))
    // console.log("mainData",mainData)
   },[activeFilters])
  
  // useEffect(()=>{
  //   if(result!==null){sendMail(validTill, id, price, unit,planName);}
  //  },[result])

  useEffect(()=>{
          const minPackage = finalwhatsappRechangePlan.reduce((prev, current) => {
              return parseFloat(prev.discountedValue || "0") <= parseFloat(current.discountedValue || "0")
                  ? prev
                  : current;
          });
          setDefaultPackage(minPackage)
           },[finalwhatsappRechangePlan])
// console.log("organizationData",organizationData)

const taginsert = async (tagg:any,packId:any,amt:any,screen?:any) => {
  const apiUrl = url+"/miscellaneous/tagUpdate";
  const payload = {
    free_trial:tagg,
    actual_packId:packId,
    actual_amount:amt,
    orgId:organizationData.organization_id,
    oid:organizationData.oid,
    screen:screen?screen:""
  };
// console.log("sendMail--payload",payload)
  try {
    const response = await axiosHandler.post(apiUrl, payload);
  //  console.log("miscellaneous done response",response)
   return response.data.data
  //  return response.rawData._id
  } catch (error:any) {
    // Handle errors
    // console.error("Error fetching responses:", error.response || error);
    throw error;
  }
};
// console.log("organizationData",organizationData)
   useEffect(()=>{
           
           // console.log("buyPrice",buyPrice)
           // {token &&
           //   // window.open(token)
             
           //   createOrder(gst,user.user_super_oid,originalPrice,originalPrice,packageId,token,isRecurringPay,`ft~${packageId}~${originalPrice}`);
           // }
           const fetchData = async () => {
            const orgData :any = await fetchOrganizationData(organizationData.organization_id)
            // console.log("orgData",orgData)
           if((orgData.WhatsAppTrialPack===true || orgData.WhatsAppTrialPack==="Y" ) && isRecurringPay==="N"){
              //  console.log("isRecurringPay===N")
               const tag = await taginsert("ft",packageId,originalPrice,"WhatsappRechangePlan")
                  // console.log("tag tag",tag)
                   {token && createOrder(gst,user.user_super_oid,originalPrice,originalPrice,packageId,token,isRecurringPay,tag._id)}
                 }else if((orgData.WhatsAppTrialPack===true || orgData.WhatsAppTrialPack==="Y" ) && isRecurringPay==="Y"){
                   const tag = await taginsert("ft",packageId,originalPrice,"WhatsappRechangePlan")
                  // console.log("tag tag",tag)
                   {token && createOrder(gst,user.user_super_oid,originalPrice,originalPrice,packageId,token,isRecurringPay,tag._id)}
                 }else{
                   console.log("else")
                   const tag = await taginsert("",packageId,originalPrice,"")
                  //  console.log("tag tag",tag)
                   {token && createOrder(gst,user.user_super_oid,originalPrice,originalPrice,packageId,token,isRecurringPay,tag._id)}
                 }}
                 fetchData();
          },[token])

   const fetchOrders = async () => {
    try {
      setLoad(true);
        const ordersList = await recurringOrders(user.user_super_oid,serviceIds);
        // console.log("ordersList", ordersList);
        setOrderData(ordersList);
        setLoad(false);
    } catch (error) {
        console.error("Error fetching orders:", error);
        setLoad(false);
    }
};

   useEffect(() => {
    fetchOrders();
}, [user.user_super_oid]);


  //  useEffect(() => {
  //   if (iframeCreated) {
  //     // Dynamically create the iframe when iframeCreated state is true
  //     const iframe = document.createElement('iframe');
  //     iframe.src = token; // Set the iframe URL
  //     iframe.title = 'DynamicIframe';
  //     iframe.style.display = "none";
  //     // iframe.contentWindow?.postMessage("parentSourceCnd", '*')
  //     // Append the iframe to the container div
  //     const container = document.getElementById('iframe-container');
  //     if (container) {
  //       container.appendChild(iframe);
  //     }
  //   }

  //   // Cleanup the iframe when the component is unmounted or iframeCreated is false
  //   return () => {
  //     if (iframeCreated) {
  //       const iframe = document.querySelector('iframe');
  //       setBricksLogin(true)
  //       if (iframe) {
  //         iframe.remove();
  //       }
  //     }
  //   };
  // }, [iframeCreated,token]);

  // console.log("section.marketingTab",section.marketingTab)
  const sendMail = async (validityDays:any,id:any,price:any,unit:any,planName:any) => {
    const apiUrl = url+"/pgi/sendMail";
    const userName = `${user.user_first_name} ${user.user_last_name}`
    const usereMail = user.user_email
    const payload = {
        email_id:usereMail,
        name:userName,
        amount:price,
        transactionId:id,
        planName:planName,
        validity:validTill,
        credits:unit,
        result:result,
        dateTime:formattedDate
    };
  // console.log("sendMail--payload",payload)
    try {
      const response = await axiosHandler.post(apiUrl, payload);
    //  console.log("Mail Sent")
    } catch (error:any) {
      // Handle errors
      // console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };

  const readProductList = async () => {
    // const apiUrl = url+"/pgi/readProductList";

    const apiUrl =url+"/pgi/readProductList"

    const payload = {
          soid: user.user_super_oid,
    };
  
    try {
      // console.log(" payload:", payload);
  
      const response = await axiosHandler.post(apiUrl, payload);

      // console.log("response",response.data.responsePayloadData.pgiRefId)
      const data = response.data;
      // console.log("data.data",data.data)
      setWhatsappRechangePlan(data.data)
      setFinalWhatsappRechangePlan(filterData(data.data,activeFilters))

    } catch (error:any) {
      // Handle errors
      console.error("Error fetching responses:", error.response || error);
      throw error;
    }
  };

  
  // useEffect(()=>{

             const fetchOrgPassDataData = async () => {
              // console.log("organizationData____fetchOrgPassDataData",organizationData)
              const PassData = await fetchOrganizationData(organizationData.organization_id)
              // console.log("orgPassData___fetchOrgPassDataData",orgPassData)
              setOrgPassData(PassData)
              // return orgPssData
            }
          //   fetchOrgPassDataData()
          // },[organizationData])

  useEffect(()=>{
            const getTag = async () => {
              const apiUrl = url+"/miscellaneous/getTag";
              const payload = {
                id:freeTrail,
              };
            console.log("sendMail--payload",payload)
              try {
                const response = await axiosHandler.post(apiUrl, payload);
                if(response?.data?.data){
                  setResPage(response.data.data)}
               console.log("miscellaneous done response",response.data)
              
              } catch (error:any) {
                // Handle errors
                console.error("Error fetching responses:", error.response || error);
                // throw error;
              }
            };
            console.log("tagout",freeTrail)
            if (freeTrail){
              console.log("tagin",freeTrail)
              getTag()
            }
          },[freeTrail])
           
          // console.log("organizationData",organizationData)
          // console.log("orgPassData",orgPassData)

  const onClickHandler = (originalPrice: any, offerPrice: any, packageId: any, validity: any, balance: any, isRec: any) => {
    // console.log("isRecisRec",isRec)
    pushToGA(
      "event_tracking",
      "read pro",
      "read pro",
      "Recharge click",
      user,
    )
    setIsRecurringPay(isRec)
    const msgData = {
      oid: user.user_super_oid,
      offerPrice: (offerPrice && offerPrice !== "0") ? offerPrice : originalPrice,
      originalPrice: originalPrice,
      packageId: packageId,
      validity: validity,
      balance: balance,
      userName: `${user.user_first_name} ${user.user_last_name}`,
      usereMail: user.user_email
    }
    localStorage.setItem("msgData", JSON.stringify(msgData));
    pgiAutoLogin(user.user_oid, (data: any) => setToken(data))
    // setIframeCreated(true)
    document.body.classList.add("no-overflow");
  };
  
  const setDataHandler = (originalPrice:any,offerPrice:any,packageId:any,validity:any,balance:any,dis:any) => {

    fetchOrgPassDataData()
    setPackageId(packageId)
    setOfferPrice(offerPrice)
    setOriginalPrice(originalPrice)
    setBalance(balance)
    setVal(validity)
    setdiscountVal(dis)
    setOpenTryAutoPayModal(true)
  };


  const recurHistory = async(Id:any,amount:any,credit:any,val:any,UnitUsed:any,orderValidityUint:any) => {
    // console.log("setHistoryAmount",amount)
    // console.log("setHistoryCredit",credit)
    // console.log("setHistoryVal",val)
    pushToGA(
      "event_tracking",
      "read pro",
      "read pro",
      "View History click",
      user,
    )
    setHistoryAmount(amount)
    setHistoryCredit(credit)
    setHistoryVal(val+" "+orderValidityUint)
    let used = (UnitUsed/credit)*100
    setHistoryUsedCredit(used)
    const historyList = await recurringHistory(user.user_super_oid,Id,serviceIds)
    // console.log("historyList",historyList)
      document.body.classList.add("no-overflow");
      setHistoryData(historyList)
      setTranId(Id)
      setAutoPayDetails(true)
      
    
  };
  const cancleRecurringPay = (Id:any) => {
    pushToGA(
      "event_tracking",
      "read pro",
      "read pro",
      "Cancel Autopay click",
      user,
    )
    cancleRecurring(Id,user.user_super_oid)
    
  };

  const shouldShowTopupButton = whatsappRechangePlan.some(
    (plan) => plan.isTopup === true && plan.discountedValue !== "0"
);
console.log("resPageresPage",resPage)
  return (
    // <iframe src="token"
    
    <div className={`${styles.WhatsRechPlan} ${styles.Parent}`}>
      {load === true && <Loading />}
       {/* <iframe 
       ref={iframeRef} // Attach a reference to the iframe
        src={token} // Assuming 'token' is the URL you want to load
        title="HiddenIframe"
        style={{ display: "none" }} // Make the iframe hidden
        // onLoad={() =>setBricksLogin(true)}
        onLoad={handleIframeLoad}
      />  */}
     {/* <div id="iframe-container"></div> */}
      <div className={styles.RechPlanHeader}>
        <div className={styles.RechPlanHeaderInner}>
          <div className={styles.RechPlanHeaderTitle}><span className={"TextBold"}>Recharge</span> WhatsApp Subscription</div>
          {
            !deviceCheck() && (
              <div className={'Breadcrums'}>
                <span className={"BreadcrumsPath"}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("/subscriptionDetails");
                  }}>Subscription</span>
                <span className={"BreadcrumsPath"}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("/whatsappRechargePlans");
                  }}>Whatsapp</span>
              </div>
            )
          }
        </div>
        {!deviceCheck() && (
          <Link to={'/rechargeTransactionHistory'} className={"CtaOutlined"}>Recharge History</Link>
        )}
      </div>
      {(pageType !== "recharge-plans") && orderData?.map((data: any) => data.success===true && (
        <div className={styles.AutoPaydetails} key={data.transactionId}>
          <div className={styles.AutoPaydetailsInner}>
            <div className={styles.AutoPaydetailTitle}>Autopay Details</div>
            <div className={styles.AtmbilpayBillCard}>
              <div className={styles.PlanCardInfo}>
                <div className={styles.PlanCardInfoi}>
                  <div className={styles.PlanCardLabel}>Plan</div>
                  <div className={styles.PlanCardData}>{data.packageAmount}</div>
                </div>
                <div className={styles.PlanCardInfoi}>
                  <div className={styles.PlanCardLabel}>Validity</div>
                  <div className={styles.PlanCardData}>{data.orderValidity+ ""+" "+data.orderValidityUint}</div>
                </div>
                <div className={styles.PlanCardInfoi}>
                  <div className={styles.PlanCardLabel}>Recharge Balance</div>
                  <div className={styles.PlanCardData}>{data.packageCredit}</div>
                </div>
                <div className={styles.PlanCardInfoi}>
                  <div className={styles.PlanCardLabel}>Remaining balance</div>
                  <div className={`${styles.PlanCardData} ${styles.PlanCardDataRb}`}>
                    {data.packageCredit - data.totalUnitUsed}
                  </div>
                </div>
              </div>
              <div className={styles.TermsWrap}>
                <div className={styles.Terms}>
                  {/* Your current package consumption stands at {((data.totalUnitUsed / data.packageCredit) * 100).toFixed(2)}%. The next payment will be triggered when remaining credits are less than {tenPercent(data.packageCredit)}. */}
                  Your current package consumption stands at {((data.totalUnitUsed / data.packageCredit) * 100).toFixed(2)}%. The next payment will be triggered when remaining credits are less than 5000.
                </div>
                <div className={styles.AtmbilpayActns}>
                  {!deviceCheck() && <span className={`${styles.AtmbilpayCtaFilled} CtaFilled`} onClick={() => recurHistory(data.transactionId,data.packageAmount,data.packageCredit,data.orderValidity,data.totalUnitUsed,data.orderValidityUint)}>View History</span>}
                  <span className={`${styles.AtmbilpayCtaOutlined} CtaOutlined`} onClick={()=>cancleRecurringPay(data.transactionId)}>Cancel Autopay</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {
        !deviceCheck() && (
          <div className={styles.RechPlanLayout}>
            <div className={styles.RechPlanTitle}>Popular plans
              <div className="planfilers">
                {shouldShowTopupButton &&(<span
                  className={`planfiltercta ${activeFilters.includes("Topup") ? "active" : ""}`}
                  onClick={() => handleFilterClick("Topup")}
                >
                  Topup
                </span>)}
                <span
                  className={`planfiltercta ${activeFilters.includes("Recharge") ? "active" : ""}`}
                  onClick={() => handleFilterClick("Recharge")}
                >
                  Recharge
                </span>
              </div>
            </div>
            <div className={styles.PlanCards}>
              {
                finalwhatsappRechangePlan?.map((plan, index) => {
                  if(plan.packageId!=="310973"){return (
                    <PlanCard
                      key={index}
                      isTopup={plan.isTopup}
                      // isPopular={plan.isPopular}
                      // isBestValue={plan.isBestValue}
                      oAmount={plan.originalValue}
                      newAmount={plan.discountedValue}
                      discount={plan.discountPercent}
                      validity={plan.validity}
                      balance={plan.balance}
                      linkTo={null}
                      ctaText="Recharge"
                      onClick={() => setDataHandler(plan.originalValue, plan.discountedValue, plan.packageId, plan.validity, plan.balance, plan.discountPercent)}
                      packageName={plan.packageName}
                    // onClick={()=>setOpenTryAutoPayModal(true)}
                    />
                  )}
                })
              }
            </div>
            {
              openGstModal &&
              <CenteredPopUp
                setModal={setOpenGstModal}
                children={
                  <GSTModal 
                  setGst={setGst}
                  PayModal={() => onClickHandler(originalPrice, offerPrice, packageId, val, balance, recr)}/>
                }
                modiferClass={styles.gstPopup}
                closeIcon={true}
              />
            }

            {
              openTryAutoPayModal &&
              <CenteredPopUp
                setModal={setOpenTryAutoPayModal}
                children={
                  <AutomaticBillPayementContent
                    setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
                    PayModal={setOpenGstModal}
                    setRecr={setRecr}
                    originalPrice={originalPrice}
                    offerPrice={offerPrice}
                    packageId={packageId}
                    setOpenTryAutoPayModal={setOpenTryAutoPayModal}
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={true}
              />
            }
            {
              openSetUpAutoPayModal &&
              <CenteredPopUp
                setModal={setOpenSetUpAutoPayModal}
                children={
                  <AutomaticBillSetUpContent
                    setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
                    setOpenRechargeProcessing={setOpenGstModal}
                    originalPrice={originalPrice}
                    offerPrice={offerPrice}
                    packageId={packageId}
                    balance={balance}
                    val={val}
                    discountVal={discountVal}
                    organizationData={orgPassData}
                    screen="WhatsappRechangePlan"
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={true}
              />
            }
            {
              openRechargeProcessing &&
              <CenteredPopUp
                setModal={setOpenRechargeProcessing}
                children={
                  <RechargeProcessingContent
                    setOpenRechargeProcessing={setOpenRechargeProcessing}
                    setRechargeResult={setRechargeResult}
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={false}
              />
            }
            {(rechargeResult && (recurringPayStatus!=="Y" ||(resPage && (resPage.marketingTab=== false || !resPage.marketingTab))))&& (
              <CenteredPopUp
                setModal={setRechargeResult}
                children={
                  <RechargeResultContent
                    setRechargeResult={setRechargeResult}
                    result={result}
                    price={price}
                    unit={unit}
                    Id={id}
                    validityDays={validityDays}
                    name={`${user.user_first_name} ${user.user_last_name}`}
                    date={formattedDate}
                    orignalPrice={orignalPrice}
                    validTill={validTill}
                    planName={planName}
                    packageId={packageId}
                    topUp={topUp}
                    uotPayStatus={uotPayStatus}
                    recurringPayStatus={recurringPayStatus}
                    tag={tag}
                    isPgiFlowAlreadyPunched={isPgiFlowAlreadyPunched}
                    // responseGst={responseGst}
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={false}
              />
            )}{(showTrialActivatedModal && resPage && resPage.marketingTab===true)&&
              (<CenteredPopUp
            setModal={setShowTrialActivatedModal}
            children={<FreeTrialActivatedModal 
              setShowTrialActivatedModal={setShowTrialActivatedModal}
              result={result}
              price={price}
              unit={unit}
              Id={id}
              validityDays={validityDays}
              name={`${user.user_first_name} ${user.user_last_name}`}
              date={formattedDate}
              orignalPrice={orignalPrice}
              validTill={validTill}
              planName={planName}
              packageId={packageId}
              topUp={topUp}
              uotPayStatus={uotPayStatus}
              recurringPayStatus={recurringPayStatus}
              tag={tag}/>}
            modiferClass={styles.ftaModal}
            closeIcon={false}
            closeClassMofifier={styles.ftaClose}
        />)}

            {
              autoPayDetails &&
              <CenteredPopUp
                setModal={setAutoPayDetails}
                children={
                  <AutoPayDetailsContent
                    setAutoPayDetails={setAutoPayDetails}
                    historyData={historyData}
                    historyAmount={historyAmount}
                    historyCredit={historyCredit}
                    historyVal={historyVal}
                    historyUsedCredit={historyUsedCredit}
                    tranId={tranId}
                  />
                }
                modiferClass={styles.Tabp}
                closeIcon={false}
              />
            }
          </div>
        )
      }
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    organizationData: state.organization.organizationData,
  };
};

export default connect(mapStateToProps)(WhatsappRechargePlans);
